import Vue from 'vue'

Vue.directive('click-outside', {
  bind(el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      if (!(el == event.target || el.contains(event.target))) {
        vnode.context[binding.expression](event)
      }
    }
    const eventName = binding.arg || 'click'
    document.body.addEventListener(eventName, el.clickOutsideEvent)
  },
  unbind(el, binding) {
    const eventName = binding.arg || 'click'
    document.body.removeEventListener(eventName, el.clickOutsideEvent)
  },
})
